'use client';
import { Tooltip as MUITooltip , IconButton } from '@mui/material';

import { TooltipProps } from './types';

export function  Tooltip({
  title,
  placement,
  children,
  isOpen,
  onClose,
  followCursor=false,
  background= 'var(--steel-100) !important',
  border=''
}: TooltipProps) {

  return (
    <MUITooltip title={title} placement={placement}  arrow followCursor={followCursor}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: background,
            color: 'var(--unique-white-10)',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            margin: '10px  !important',
            border: border       
          },
        },
        arrow:{
          sx:{
            color: background,
            '&::before': {
              border: border,
            }
          } 
        }
      }}
    > 
      {children}
    </MUITooltip>
  );
}
